<div class="exception-body">
  <div class="exception-panel">
      <h1>Email Verification</h1>
      <p>A verification email has been sent to <strong>{{ email }}</strong>. Please verify your email address by clicking the link in the email.</p>

      <button pButton label="Resend Email" type="button" class="ui-button raised-btn" (click)="resendEmail()"></button>
  </div>
</div>